"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var _systemadmin = _interopRequireWildcard(require("@/api/systemadmin.js"));
var systemAdminApi = _systemadmin;
var _validate = require("@/utils/validate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  // name: "edit"
  components: {},
  props: {
    adminId: {
      type: Number,
      required: 0
    }
  },
  data: function data() {
    var _this = this;
    var confirmvalidatePass = function confirmvalidatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.pram.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入管理员密码'));
      } else {
        if (_this.pram.confirmPassword !== '') {
          _this.$refs.pram.validateField('confirmPassword');
        }
        callback();
      }
    };
    return {
      constants: this.$constants,
      pram: {
        password: '',
        confirmPassword: '',
        id: 0
      },
      roleList: [],
      rules: {
        password: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }, {
          required: true,
          min: 6,
          max: 20,
          message: '长度6-20个字符'
        }],
        confirmPassword: [{
          required: true,
          message: '确认密码密码',
          validator: confirmvalidatePass,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    close: function close() {
      this.$emit('hideEditPassWordDialog');
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.handlerSave();
      });
    }),
    handlerSave: function handlerSave() {
      var _this3 = this;
      this.pram.id = this.adminId;
      systemAdminApi.editPassWordApi(this.pram).then(function (data) {
        _this3.$message.success('修改密码成功');
        _this3.$emit('hideEditPassWordDialog');
      });
    },
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    }
  }
};